import { render, staticRenderFns } from "./follow.vue?vue&type=template&id=ba98fbc2&scoped=true"
import script from "./follow.vue?vue&type=script&lang=js"
export * from "./follow.vue?vue&type=script&lang=js"
import style0 from "./follow.vue?vue&type=style&index=0&id=ba98fbc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba98fbc2",
  null
  
)

export default component.exports